<template>
  <div id="banner-logo">
    <div class="dual-logo">
      <img v-if="!isFrench" class="logo assante desktop" src="~@/assets/images/assante/logo_horizontal.svg" :alt="brandName">
      <img v-if="!isFrench" class="logo assante mobile" src="~@/assets/images/assante/logo_vertical.svg" :alt="brandName">
      <img v-if="isFrench" class="logo assante desktop" src="~@/assets/images/assante/logo_horizontal_fr.svg" :alt="brandName">
      <img v-if="isFrench" class="logo assante mobile" src="~@/assets/images/assante/logo_vertical_fr.svg" :alt="brandName">
      <p class="banner-logo-string"><strong v-t>Advisor</strong></p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    brandName: {
      type: String,
      default: '',
    },
  },
  computed: {
    isFrench() { return this.$lang === 'fr-CA'; },
  },
};
</script>

<style lang="scss" scoped>
  #banner-logo {
    .mobile { display: block; }
    .desktop { display: none; }

    @media #{$screen-width-medium} {
      .desktop { display: block; }
      .mobile { display: none; }
    }

    .dual-logo {
      display: flex;
      align-items: center;
      height: 2.75rem;

      img.desktop { height: 1.375rem; }
      img.mobile { height: 2.25rem; }

      .banner-logo-string {
        margin: 0;
        margin-left: .6875rem;
      }
    }
  }

</style>
